/**
 * Footer disclaimer. Copy is verbatim from www/app/views/accumulator.html —
 * it is member-facing compliance wording, so do not reword it.
 */
export function AccumulatorDisclaimer() {
  return (
    <div className="accumulator-disclaimer-wrapper">
      <div className="accumulator-disclaimer-container">
        <p>
          Accumulator amounts listed are based on the most recent information we have at the time of
          display. Individual accumulator amounts shown apply to the member that is logged in.
          Copayment assistance and other third-party payments are not included in the calculation of
          your deductible and out-of-pocket maximum. For more information on your accumulators,
          please refer to your benefit plan documentation.
        </p>
      </div>
    </div>
  );
}
